export const initBladeDetailsData = {
  selectedBlade: {},
  bladeVariants: [],
  cutType: {}
}
